import React from 'react';
import { Shield, Users, Star, AlertCircle, Search, Filter, BarChart3 } from 'lucide-react';
import { Card } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { useAuth } from '../../contexts/AuthContext';
import { motion } from 'framer-motion';

const CoachDashboard: React.FC = () => {
  const { user } = useAuth();

  // TODO: Get coach data from profile
  const coachName = user?.email?.split('@')[0] || 'Coach';
  const institution = 'Your Institution'; // TODO: Get from profile

  return (
    <div className="min-h-screen bg-gradient-to-br from-rowing-gray-50 to-white p-6">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          className="mb-8"
        >
          <h1 className="text-4xl font-display font-bold text-rowing-navy mb-2">
            Welcome, {coachName}
          </h1>
          <p className="text-rowing-gray-600">{institution} Rowing Program</p>
        </motion.div>

        {/* Compliance Warning */}
        <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mb-6">
          <div className="flex items-start">
            <AlertCircle className="h-5 w-5 text-amber-600 mt-0.5 mr-3" />
            <div>
              <h3 className="text-sm font-semibold text-amber-800 mb-1">NCAA Compliance Notice</h3>
              <p className="text-sm text-amber-700">
                All communications and recruiting activities must comply with NCAA Division
                regulations. Dead period restrictions are currently in effect until January 1, 2025.
              </p>
            </div>
          </div>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
          <Card>
            <div className="p-6">
              <div className="flex items-center justify-between mb-4">
                <Users className="h-8 w-8 text-blue-600" />
                <span className="text-2xl font-bold text-gray-900">0</span>
              </div>
              <h3 className="text-sm font-medium text-gray-600">Athletes Viewing</h3>
              <p className="text-xs text-gray-500 mt-1">With consent</p>
            </div>
          </Card>

          <Card>
            <div className="p-6">
              <div className="flex items-center justify-between mb-4">
                <Star className="h-8 w-8 text-yellow-500" />
                <span className="text-2xl font-bold text-gray-900">0</span>
              </div>
              <h3 className="text-sm font-medium text-gray-600">Starred Athletes</h3>
              <p className="text-xs text-gray-500 mt-1">Your watchlist</p>
            </div>
          </Card>

          <Card>
            <div className="p-6">
              <div className="flex items-center justify-between mb-4">
                <Shield className="h-8 w-8 text-green-600" />
                <span className="text-sm font-semibold text-green-600">Verified</span>
              </div>
              <h3 className="text-sm font-medium text-gray-600">Account Status</h3>
              <p className="text-xs text-gray-500 mt-1">NCAA compliant</p>
            </div>
          </Card>
        </div>

        {/* Quick Actions */}
        <Card>
          <div className="p-6">
            <h2 className="text-lg font-semibold text-gray-900 mb-4">Quick Actions</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <Button
                variant="primary"
                className="w-full"
                onClick={() => {
                  /* TODO: Navigate to athlete search */
                }}
              >
                Search Athletes
              </Button>
              <Button
                variant="secondary"
                className="w-full"
                onClick={() => {
                  /* TODO: Navigate to starred athletes */
                }}
              >
                View Watchlist
              </Button>
            </div>
          </div>
        </Card>

        {/* Coming Soon Features */}
        <div className="mt-8 text-center text-gray-500">
          <p className="text-sm">Telemetry data integration and advanced analytics coming soon!</p>
        </div>
      </div>
    </div>
  );
};

export default CoachDashboard;
